import { Component, Input } from '@angular/core';
import { MenuItem } from '../../models/menu-item.model';
import { SlideMenuService } from '../../services/slide-menu/slide-menu.service';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent {

  @Input() menuItem?: MenuItem;
  @Input() colorClass: string = '';

  constructor(
    public slideMenuService: SlideMenuService
  ) { }

}
